import React, { useCallback, useEffect } from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";

import ConversationList from "./ConversationList";
import SearchInput from "./SearchInput";

import Loader from "../Loader";
import NewConversationButton from "./NewConversationButton";
import NoConversations from "./NoConversations";
import SettingsButton from "./SettingsButton";

import { useAppSelector, useAppDispatch } from "../../hooks/reduxhook";
import {
  getConversations,
  getFilteredConversations,
  setSearchQuery,
  clearActiveChat,
} from "../../redux/slices/conversationSlice";
import { getloadingforconversations } from "../../redux/slices/loadingSlice";

const drawerWidth = 290;

export default function LeftSidebar() {
  const dispatch = useAppDispatch();
  const conversations = useAppSelector(getConversations);
  const filteredConversations = useAppSelector(getFilteredConversations);
  const loading = useAppSelector(getloadingforconversations);

  // Initialize search from session storage
  useEffect(() => {
    const savedSearch = sessionStorage.getItem("conversation_search") || "";
    if (savedSearch) {
      dispatch(setSearchQuery(savedSearch));
    }
  }, [dispatch]);

  const handleSearch = useCallback(
    (query: string) => {
      dispatch(setSearchQuery(query));
    },
    [dispatch]
  );

  // const handleNewChat = useCallback(() => {
  //   dispatch(clearActiveChat());
  // }, [dispatch]);

  const displayConversations =
    filteredConversations.length > 0 || conversations.length === 0
      ? filteredConversations
      : conversations;
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      {/* <NewConversationButton onClick={handleNewChat} /> */}
      <NewConversationButton />
      {/* {conversations?.length > 0 && <DeleteAllConversationsButton />} */}
      {conversations?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 0.5,
          }}
        >
          <SearchInput onSearch={handleSearch} />
        </Box>
      )}
      <Divider />
      {loading && <Loader />}
      <Box
        id="conversationlist"
        sx={{
          overflow: "auto",
          flex: 1,
        }}
      >
        <div>
          {conversations?.length === 0 ? (
            <NoConversations />
          ) : displayConversations?.length === 0 ? (
            <Box sx={{ p: 2, textAlign: "center", color: "text.secondary" }}>
              No conversations found
            </Box>
          ) : (
            displayConversations?.map((conv) => (
              <ConversationList
                key={conv?.id}
                name={conv?.conv_name}
                conversation_id={conv?.id}
                date={conv?.time}
              />
            ))
          )}
        </div>
      </Box>
      <SettingsButton />
    </Drawer>
  );
}
